import { ConfigProvider, Modal } from "antd";
import zhCN from "antd/lib/locale/zh_CN";
import classNames from "classnames";
import HBIcon from "../HBIcon";
import styles from "./index.module.less";

/**
 * @typedef {import("antd").ModalProps} ModalProps
 * @param {ModalProps | any} props
 * @returns
 */
export default function HBModal(props) {
  return (
    <ConfigProvider autoInsertSpaceInButton={false} locale={zhCN}>
      <Modal
        cancelButtonProps={{ type: "text" }}
        closeIcon={<HBIcon type="ic_close" />}
        centered
        {...props}
        wrapClassName={classNames(styles.modal, props.wrapClassName)}
      />
    </ConfigProvider>
  );
}
